import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCmmQ8GbARixYjYlpvKM6c3zkqineE1Dyo",
  authDomain: "sugarbakestwist.firebaseapp.com",
  databaseURL: "https://sugarbakestwist-default-rtdb.asia-southeast1.firebasedatabase.app/",  // **Ensure your Realtime Database URL is correct**
  projectId: "sugarbakestwist",
  storageBucket: "sugarbakestwist.appspot.com",  // **Fixed URL (was incorrect)**
  messagingSenderId: "295026166457",
  appId: "1:295026166457:web:c35e6233c477bad7b92968",
  measurementId: "G-EB2D5SF81Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);  // ✅ Added Realtime Database support

export { app, auth, database };
